import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from '../../app/shared/services/auth.service';
import { Router } from '@angular/router';
import { UserService } from '../../app/shared/services/user.service';
import { Observable} from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router, private userService: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = this.authService.currentUserValue;
        if (currentUser && currentUser.token) {
            request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${currentUser.token}`
            }
            });
        }
        return next.handle(request);
      }
}
